<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h4>Main Screen</h4>
      <p>The Main Screen consists of two tabs:</p>
      <ul class="Vlt-list Vlt-list--simple">
        <li>Chat List</li>
        <li>My Profile</li>
      </ul>

      <h5>Chat List Tab</h5>

      <div style="display: flex; flex-direction: row; width: 100%;">
        <div style="margin-right: 16px; display: flex; flex: 1; flex-direction: column;">
          <p>On the Chat Tab, you will see the following screen, with a list of active chat the current user is in.</p>

          <p>At the bottom of the screen, there is a button to create new conversation from your contact list.</p>
        </div>

        <img src="https://vids.vonage.com/pages/inapp-android/image5.jpg" width="240" alt="image5" />
      </div>

      <h5>My Profile Tab</h5>

      <div style="display: flex; flex-direction: row; width: 100%;">
        <div style="margin-right: 16px; display: flex; flex: 1; flex-direction: column;">
          <p>On the Profile Tab, it shows information on the current user and connection.</p>

          <p>The information includes:</p>
          <ul class="Vlt-list Vlt-list--simple">
            <li>Nexmo Application User ID</li>
            <li>Mobile Number (name in Nexmo Application User)</li>
            <li>Display Name retrieved via Nexmo SDK</li>
            <li>Display Name retrieved via API (in-app demo server self hosted database, specified during first time
              login)</li>
            <li>Data Center region (sg, eu, us)</li>
            <li>API Host used</li>
            <li>WS Host used</li>
          </ul>




          <p>At the bottom of the screen, there is a logout button, for logging out of the app and get to other Data
            Center or user.</p>
        </div>

        <img src="https://vids.vonage.com/pages/inapp-android/image6.jpg" width="240" alt="image6" />
      </div>
    </div>

  </section>

</template>

<script lang="js">
export default {
  name: 'demo',
  components: {
  },
  props: {
    nexmo: {
      type: Object,
      required: false
    }
  },
}
</script>

<style scoped lang="scss"></style>